import { version } from "../package.json";

const config = {
  version: version,
  mode: import.meta.env.MODE || "development",
  env: import.meta.env.VITE_ENVIRONMENT,
  emulator: import.meta.env.VITE_EMULATOR === "true",
  firebase: {
    apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
    authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
    projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
    storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
    appId: import.meta.env.VITE_FIREBASE_APP_ID,
  },
  collections: {
    users: "users",
    accounts: "accounts",
    config: "config",
    tenants: "tenants",
  },
  urls: {
    admin: import.meta.env.VITE_ADMIN_URL,
    api: import.meta.env.VITE_API_URL,
    billing: import.meta.env.VITE_STRIPE_PORTAL_LINK,
    messageService: import.meta.env.VITE_MESSAGE_SERVICE_URL,
  },
};

if (config.env === "staging" || config.env === "production") {
  const protocol = location.protocol + "//";
  const host = location.hostname;

  /** Get colon and port from domain-port string, or empty string if no port is present. */
  const getPort = (origin: string) => {
    const url = new URL(origin);
    return url.port ? ":" + url.port : "";
  };

  config.urls.admin = protocol + host + getPort(config.urls.admin);
  config.urls.api = protocol + "api." + host + getPort(config.urls.api);
  config.urls.messageService =
    protocol + "messaging." + host + getPort(config.urls.messageService);
}

console.log(config);
export { config };
